// Maps Divii agreement province names → holiday-schedule jurisdiction codes.
const PROVINCE_TO_CODE = {
	alberta: 'AB',
	'british columbia': 'BC',
	manitoba: 'MB',
	'new brunswick': 'NB',
	'newfoundland and labrador': 'NL',
	'nova scotia': 'NS',
	nunavut: 'NU',
	'northwest territories': 'NT',
	ontario: 'ON',
	'prince edward island': 'PE',
	saskatchewan: 'SK',
	yukon: 'YT',
};

export const PROVINCE_NAMES = {
	AB: 'Alberta',
	BC: 'British Columbia',
	MB: 'Manitoba',
	NB: 'New Brunswick',
	NL: 'Newfoundland & Labrador',
	NS: 'Nova Scotia',
	NT: 'Northwest Territories',
	NU: 'Nunavut',
	ON: 'Ontario',
	PE: 'Prince Edward Island',
	SK: 'Saskatchewan',
	YT: 'Yukon',
};

export default function holidayScheduleJurisdiction(agreement) {
	const raw =
		agreement?.agreement?.updatedProvinceOfAgreement ||
		agreement?.agreement?.provinceOfAgreement ||
		agreement?.provinceOfAgreement ||
		'';
	const normalized = String(raw).trim().toLowerCase();
	if (PROVINCE_TO_CODE[normalized]) {
		return PROVINCE_TO_CODE[normalized];
	}
	// Already a short code (e.g. BC, ON)
	const upper = String(raw).trim().toUpperCase();
	if (upper.length === 2 && Object.values(PROVINCE_TO_CODE).includes(upper)) {
		return upper;
	}
	return 'BC';
}
